import React from 'react';
import {
  MemoryRouter as Router,
  // BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from 'react-router-dom';


/**
 * Import pages with paths
 */
import {
  WhatGoesWhere,
  MaterialDetails,
  DepoEventList,
  DepoEventDetails,
  GeneralPage,
} from '../pages';


/**
 * Public route constants
 */
const routeConsts = {
  home: '/wgw',
  materialDetails: '/material-details',
  depoList: '/depo-list',
  eventList: '/event-list',
  depoDetails: '/depo-details',
  eventDetails: '/event-details',
  generalPage: '/general-page'
};


/**
 * Root Router
 */
const Routes = () => {
  const {
    home,
    materialDetails,
    depoList,
    depoDetails,
    eventList,
    eventDetails,
    generalPage,
  } = routeConsts;

  return (
    <Router keyLength={15}>
      <Switch>
        <Redirect
          exact
          from="/"
          to="/wgw"
        />
        <Route
          path={home}
          render={() => <WhatGoesWhere />}
        />
        <Route
          path={materialDetails}
          key={() => Math.random()}
          exact
          render={() => <MaterialDetails />}
        />
        <Route
          path={depoList}
          key={() => Math.random()}
          exact
          render={() => <DepoEventList />}
        />
        <Route
          path={eventList}
          key={() => Math.random()}
          exact
          render={() => <DepoEventList />}
        />
        <Route
          path={depoDetails}
          key={() => Math.random()}
          exact
          render={() => <DepoEventDetails />}
        />
        <Route
          path={eventDetails}
          key={() => Math.random()}
          exact
          render={() => <DepoEventDetails type="event" />}
        />
        <Route
          path={generalPage}
          key={() => Math.random()}
          exact
          render={() => <GeneralPage />}
        />
      </Switch>
    </Router>
  );
};

export default Routes;
